// Code of the Parse error with which the server refuses a request of a user
// who has not set up their second factor. An application code, outside the
// range the Parse SDK defines its own in (those end at 602).
export const SECOND_FACTOR_REQUIRED = 1001;
